export interface AdvancedFiltersState {
  domains: string[]
  threatGroups: string[]
  countries: string[]
  threatTypes: string[]
}

export const ThreatTypesOptions = [
  { value: 'Automation tool', label: 'Automation tool' },
  { value: 'Disabled Cookies', label: 'Disabled Cookies' },
  { value: 'Disabled JS', label: 'Disabled JS' },
  { value: 'Excessive rate limit', label: 'Excessive rate limit' },
  { value: 'False Representation', label: 'False Representation' },
  { value: 'Scrapers', label: 'Scrapers' },
  { value: 'Malicious Bots', label: 'Malicious Bots' },
  { value: 'Account Takeover', label: 'Account Takeover' },
  { value: 'Click Hijacking', label: 'Click Hijacking' },
]

export const ThreatGroupOptions = [
  { value: 'Invalid Bot Activity', label: 'Invalid Bot Activity' },
  { value: 'Invalid Malicious Activity', label: 'Invalid Malicious Activity' },
]

export type FilterCategory = 'domains' | 'threatGroups' | 'countries' | 'threatTypes'

export type ActiveFilterType = {
  name: string
  values: string[]
}

export const categoryToFilter = [
  { value: 'domains', name: 'Domain' },
  { value: 'threatGroups', name: 'Threat Group' },
  { value: 'countries', name: 'Country' },
  { value: 'threatTypes', name: 'Threat Type' },
]
